import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { RecrystaMark } from "@/components/RecrystaLogo";

export default function PrivacyPage() {
  return (
    <div className="min-h-screen w-full bg-slate-50 text-slate-900" data-testid="privacy-page">
      <header className="border-b border-slate-200 bg-white">
        <div className="max-w-3xl mx-auto px-6 lg:px-10 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <RecrystaMark size={32} />
            <span className="text-sm font-bold tracking-tight">Recrysta</span>
          </Link>
          <Link to="/" className="text-sm text-slate-600 hover:text-slate-900 inline-flex items-center gap-1">
            <ArrowLeft className="h-3.5 w-3.5" /> Back to home
          </Link>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-6 lg:px-10 py-12 prose prose-slate">
        <div className="text-[11px] uppercase tracking-[0.22em] text-slate-500 font-semibold">Legal</div>
        <h1 className="mt-2 text-3xl sm:text-4xl font-extrabold tracking-tight">Privacy Policy</h1>
        <p className="mt-2 text-sm text-slate-500">Placeholder — the definitive version will be prepared with counsel before we take real payments in production.</p>

        <section className="mt-8 space-y-4 text-slate-700 text-[15px] leading-relaxed">
          <p>
            Recrysta provides revenue forecasting software for HubSpot customers.
            This page summarises how we handle personal data. It is written in plain
            English and is not a substitute for a formal Data Processing Agreement,
            which is available on request.
          </p>

          <h2 className="text-xl font-bold text-slate-900 mt-8">What we store</h2>
          <ul className="list-disc pl-5 space-y-1.5">
            <li>Your account details: email, hashed password, workspace name, timezone.</li>
            <li>Your HubSpot deals, pipelines, owners and pipeline mappings — pulled via
            the read-only scopes you grant during OAuth.</li>
            <li>HubSpot OAuth tokens, encrypted at rest with AES-GCM.</li>
            <li>Analytics events describing your interaction with the product
            (page views, feature usage) — no keystroke or content-level tracking.</li>
          </ul>

          <h2 className="text-xl font-bold text-slate-900 mt-8">Where it lives</h2>
          <p>All storage is inside the European Union.</p>

          <h2 className="text-xl font-bold text-slate-900 mt-8">AI processing</h2>
          <p>
            Weekly briefings are generated using enterprise-grade AI providers under
            contractual no-training terms. Nothing you send us is used to train any
            model. Only pseudonymised metrics and deal names are sent to the AI — no
            contact emails, no company descriptions, no owner PII.
          </p>

          <h2 className="text-xl font-bold text-slate-900 mt-8">Your rights (GDPR)</h2>
          <p>
            You may request access, correction, deletion or portability of your data
            at any time by emailing <a className="text-slate-900 underline" href="mailto:support@recrysta.com">support@recrysta.com</a>.
          </p>

          <h2 className="text-xl font-bold text-slate-900 mt-8">Data Processing Agreement</h2>
          <p>
            A standard DPA covering GDPR Article 28 is available on request at
            <a className="ml-1 text-slate-900 underline" href="mailto:support@recrysta.com">support@recrysta.com</a>.
          </p>

          <h2 className="text-xl font-bold text-slate-900 mt-8">Sub-processors</h2>
          <p>
            HubSpot (source CRM, user-authorised), Anthropic (AI briefing generation
            under no-training terms), Resend (transactional email), Stripe (billing).
            A complete, up-to-date list will be maintained alongside the formal DPA.
          </p>
        </section>
      </main>
    </div>
  );
}
